import { SuccessCaseContentItem } from "@whyuz/services";

export interface SuccessCaseQuestionCardTextProps {
  question: SuccessCaseContentItem;
}
export const SuccessCaseQuestionCardText = ({ question }: SuccessCaseQuestionCardTextProps) => {
  return <span className="text-xs p-5 italic text-gray-500 dark:text-gray-400">{question.htmlTextContent}</span>;
};
